import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { primeHoldingActions } from "stores/jarvisPrime/primeHolding/primeHoldingActions";

const mapStateToProps = (state) => {
  return {
    primeHoldingList: state.jarvisPrime.primeHolding.primeHoldingList,
    portfolioOverviewData: state.jarvisPrime.primeDashboard.portfolioOverview,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPrimeHoldingListActions: primeHoldingActions.getPrimeHoldingList,
    },
    dispatch
  );

const PrimeHoldingStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default PrimeHoldingStore;
